/**
 * Formats a claims-style address (with optional addressee lines) into a single
 * comma-separated string.  Returns `'N/A'` when the address is absent or empty.
 */
export const formatClaimAddress = (
  addr:
    | {
        line1?: string | null;
        line2?: string | null;
        addressee1?: string | null;
        addressee2?: string | null;
        city?: string | null;
        state?: string | null;
        zipCode?: string | null;
      }
    | null
    | undefined,
): string => {
  if (!addr) return 'N/A';
  const parts: string[] = [];
  if (addr.addressee1) parts.push(addr.addressee1);
  if (addr.addressee2) parts.push(addr.addressee2);
  if (addr.line1) parts.push(addr.line1);
  if (addr.line2) parts.push(addr.line2);
  const cityStateZip = [
    addr.city && addr.state ? `${addr.city},` : addr.city,
    addr.state,
    addr.zipCode,
  ]
    .filter(Boolean)
    .join(' ');
  if (cityStateZip) parts.push(cityStateZip);
  return parts.length > 0 ? parts.join(', ') : 'N/A';
};
